module.exports = __webpack_public_path__ + "img/footer1.f2f4f848.svg";